import { SearchIcon } from "lucide-react";

import { Button } from "@/components/ui/button";

import { useHandleDefaultSearchForJob } from "@/hooks";
import { Job } from "@/types";

export const JobPipelineTableEmptyState = ({ job }: { job: Job }) => {
  const handleDefaultSearchForJob = useHandleDefaultSearchForJob();

  return (
    <div className="flex flex-col items-center justify-center gap-6 bg-slate-50 py-28">
      <div className="flex flex-col items-center gap-4">
        <SearchIcon className="h-28 w-28 stroke-[1px] text-slate-600" />
        <p className="text-3xl font-semibold text-slate-600">
          No candidates yet
        </p>
        <p className="text-xl text-slate-500">
          Start searching to find and shortlist qualified candidates
        </p>
        <Button
          className="rounded-full"
          onClick={() => {
            handleDefaultSearchForJob({ job });
          }}
          variant="outline"
        >
          Search Candidates
        </Button>
      </div>
    </div>
  );
};
